/**
 * GoSportFAB - Bouton flottant d'accès au module Go Sport
 * Style similaire au RewardsFAB avec thème orange/sportif
 */

import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Dumbbell, Flame, Zap } from 'lucide-react';

export const GoSportFAB = memo(function GoSportFAB({
  streak = 0,
  hasProfile = false,
  onClick,
}) {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="relative"
    >
      {/* Glow effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-red-500 rounded-full blur-lg opacity-50" />

      {/* Button */}
      <div className={`
        relative w-14 h-14 rounded-full
        bg-gradient-to-br from-orange-500 to-red-500
        flex items-center justify-center
        shadow-lg shadow-orange-500/30
        ${!hasProfile ? 'animate-bounce' : ''}
      `}>
        <Dumbbell className="w-6 h-6 text-white" />

        {/* Badge streak */}
        {streak > 0 && (
          <div className="absolute -top-1 -right-1 min-w-[24px] h-6 px-1.5
            bg-yellow-500 rounded-full flex items-center justify-center gap-0.5">
            <Flame className="w-3 h-3 text-yellow-900" />
            <span className="text-[10px] font-bold text-yellow-900">
              {streak}
            </span>
          </div>
        )}

        {/* Indicateur nouvelle séance disponible */}
        {hasProfile && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="absolute -bottom-1 -left-1 w-6 h-6 bg-emerald-500 rounded-full
              flex items-center justify-center shadow-lg"
          >
            <Zap className="w-3 h-3 text-white" />
          </motion.div>
        )}
      </div>
    </motion.button>
  );
});

export default GoSportFAB;
